export function formatPhoneNumberHref(phoneNumber) {
  if (!phoneNumber) return '';

  if (phoneNumber.includes('+1')) return `${phoneNumber.replace(/\D/g, '')}`;
  return `+1${phoneNumber.replace(/\D/g, '')}`;
}
